<template>
  <div
    v-if="policy.participantType === 'CUSTOMER'"
    class="agent-service-mode-switch"
    aria-label="客服回复模式"
  >
    <button
      type="button"
      :class="displayedMode === 'agent' ? 'is-agent' : 'is-human'"
      :aria-pressed="displayedMode === 'agent'"
      :title="displayedMode === 'agent' ? 'Agent' : '真人'"
      :aria-label="`当前为${
        displayedMode === 'agent' ? 'Agent' : '真人'
      }模式，点击切换`"
      :disabled="changing || controlState === 'CLOSED'"
      @click="toggleMode"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <g stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
          <rect x="5" y="7" width="14" height="12" rx="4" />
          <path d="M12 3v4M3 11v4m18-4v4M9 15h6" />
          <circle cx="9" cy="11" r="1" fill="currentColor" stroke="none" />
          <circle cx="15" cy="11" r="1" fill="currentColor" stroke="none" />
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
/** 客户端模式选择器先完成视觉反馈，再由父容器提交服务端状态变更。 */
export default {
  name: "AgentServiceModeSwitch",
  props: {
    policy: { type: Object, required: true },
    controlState: { type: String, default: "" },
    changing: { type: Boolean, default: false },
  },
  data() {
    return { optimisticMode: "" };
  },
  computed: {
    authoritativeMode() {
      return this.controlState === "AI_ENABLED" ? "agent" : "human";
    },
    displayedMode() {
      return this.optimisticMode || this.authoritativeMode;
    },
  },
  watch: {
    controlState() {
      if (this.optimisticMode === this.authoritativeMode) {
        this.optimisticMode = "";
      }
    },
    changing(next, previous) {
      if (previous && !next) this.optimisticMode = "";
    },
  },
  methods: {
    /** 单按钮每次点击切到另一种模式，外观立即变化，权威状态随后校准。 */
    toggleMode() {
      if (this.changing || this.controlState === "CLOSED") return;
      const mode = this.displayedMode === "agent" ? "human" : "agent";
      this.optimisticMode = mode;
      this.$emit("mode-change", mode);
    },
  },
};
</script>

<style lang="less" scoped>
.agent-service-mode-switch {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    min-width: 44px;
    height: 44px;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--m-text-secondary, #667085);
    cursor: pointer;
    transition: color 160ms ease;

    svg {
      width: 22px;
      height: 22px;
      filter: drop-shadow(0 1px 1px rgba(15, 23, 42, .16));
    }
    &.is-agent { color: var(--m-brand-600, #246de0); }
    &:focus-visible { outline: 2px solid #4286f5; outline-offset: -2px; border-radius: 8px; }
    &:disabled { cursor: not-allowed; opacity: .6; }
    @media (prefers-reduced-motion: reduce) { transition: none; }
  }
}
</style>
